import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { EXTRA_REWARDS_FILTER, SALE_FILTER } from 'core/modules/ProductSearchResults/utils/keys';
import {
  selectProductSearchResultInitialFacets, selectProductSearchResultsConfig,
} from 'core/modules/ProductSearchResults/selectors';
import { triggerPsrClearFilterGaEvent } from 'core/modules/ProductSearchResults/actions';
import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';

function ActiveFiltersDesktop({ filterHook, sortedActiveFilters }) {
  const dispatch = useDispatch();
  const initialFacets = useSelector(selectProductSearchResultInitialFacets);
  const { filterOptions } = useSelector(selectProductSearchResultsConfig);
  const { extraRewardsName, saleName } = filterOptions;
  const { clearIdsInFilter, removeIdFromFilter } = filterHook;

  const getFilteredItemLabelById = (key, id) => {
    if (key === EXTRA_REWARDS_FILTER) {
      return extraRewardsName;
    }

    if (key === SALE_FILTER) {
      return saleName;
    }

    const facet = initialFacets[key];
    const value = facet.values.find((values) => values.id === id);

    return value.label;
  };

  const handleClearId = (key, id) => {
    removeIdFromFilter(key, id);
    dispatch(triggerPsrClearFilterGaEvent());
  };

  const handleClearIds = () => {
    clearIdsInFilter();
    dispatch(triggerPsrClearFilterGaEvent());
  };

  return (
    <div className="mn_activeFiltersWrap">
      {!!sortedActiveFilters.length &&
        <div className="mn_activeFilters">
          <button className="mn_clearFilters" onClick={handleClearIds}>Clear filters</button>
          {sortedActiveFilters.map(({ key, id }) => (
            <div key={`${key}${id}`} className="mn_activeFilter">
              <span>{getFilteredItemLabelById(key, id)}</span>
              <button
                onClick={() => handleClearId(key, id)}
                aria-label={`Clear filter by ${getFilteredItemLabelById(key, id)}`}
              >
                &#x2715;
              </button>
            </div>
          ))}
        </div>
      }
    </div>
  );
}

export default (props) => <ComponentErrorBoundary><ActiveFiltersDesktop {...props} /></ComponentErrorBoundary>;
